/* jslint es6 */
import Navigation from "../nav";
import Search from "../search";
import throttle from "lodash.throttle";

function Header() {
    var that = this;
    var doc = document.documentElement;
    var lastScroll = 0;
    this.header = document.querySelector(".header");
    this.navigation = new Navigation();
    this.search = new Search();

    var scroll = throttle(function () {
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top > 0) {
            that.header.classList.remove("top");
            if (top < lastScroll && top > 0) {
                that.header.classList.add("float");
                top++; // Fix for ie - trick that fixes showing/hiding on every scroll
            } else {
                that.header.classList.remove("float");
            }
        } else {
            that.header.classList.add("top");
            that.header.classList.remove("float");
        }
        lastScroll = top;
    }, 100);

    scroll();
    window.addEventListener("scroll", scroll);
}

export default Header;



// WEBPACK FOOTER //
// ./js/components/header/index.js